import { __assign, __awaiter, __extends, __generator } from "tslib";
import { TimeBasedRateLimiter } from "./TimeBasedRateLimiter.mjs";
var TimedPassthruRateLimiter = /** @class */ (function (_super) {
    __extends(TimedPassthruRateLimiter, _super);
    function TimedPassthruRateLimiter(child, config) {
        return _super.call(this, __assign(__assign({}, config), { doRequest: function (req) {
                return __awaiter(this, void 0, Promise, function () {
                    return __generator(this, function (_a) {
                        return [2 /*return*/, child.request(req)];
                    });
                });
            } })) || this;
    }
    return TimedPassthruRateLimiter;
}(TimeBasedRateLimiter));
export { TimedPassthruRateLimiter };
